module.exports = __webpack_public_path__ + "static/media/IconStop.a9ec2987.svg";